import { serverAddr } from "../networkConfig";

export default {
    getTrainingType(param) {
        return serverAddr.get(`/train/training_view/view-training/`);
    },
    getTrainingSchedule(param) {
        return serverAddr.get(`/train/training_schedule/view-schedule/?start_date=${param.start_date}&end_date=${param.end_date}&store_id=${param.store_id}`);
    },
    createUpdateTrainingType(payload) {
        return serverAddr.post(`/train/training_view/create-or-update/`, payload);
    },
    deleteTrainingType(payload) {
        return serverAddr.post(`/train/training_view/delete/`, payload);
    },
    createUpdateTrainings(payload) {
        return serverAddr.post(`/train/training_schedule/create-or-update/`, payload);
    },
    deleteTraining(payload) {
        return serverAddr.post(`/train/training_schedule/delete/`, payload);
    },
    getStoreEmployees(payload) {
        return serverAddr.post(`/read/employees/`, payload);
    },
    getStation(storeID) {
		return serverAddr.post("read/store-functions/", storeID);
	},
    getAllStores() {
		return serverAddr.get("/outlet/?get_all=true&type=central_kitchen,store");
	},
    getDesignation(params) {
		return serverAddr.post(`/store-designations/list/`, params);
	},
    getStoreSections(params) {
		return serverAddr.post(`/read/store_sections/`, params);
	},
    getDepartment(storeID) {
		return serverAddr.post("/read/store-departments/", storeID);
	},
}